import { yupResolver } from '@hookform/resolvers/yup';
import type { FieldValues, UseFormProps, UseFormReturn, ValidationMode } from 'react-hook-form';
import { useForm as useRHForm, useFormContext as useRHFormContext } from 'react-hook-form';
import type * as yup from 'yup';

interface UseFormOptions<
  TFieldValues extends FieldValues = FieldValues,
  TContext = unknown,
  TTransformedValues = TFieldValues,
> extends Omit<UseFormProps<TFieldValues, TContext, TTransformedValues>, 'resolver'> {
  schema: yup.ObjectSchema<TFieldValues, unknown, TTransformedValues, yup.Flags>;
  validationMode?: keyof ValidationMode;
}

export function useForm<
  TFieldValues extends FieldValues = FieldValues,
  TContext = unknown,
  TTransformedValues = TFieldValues,
>({
  schema,
  validationMode = 'onChange',
  ...rest
}: UseFormOptions<TFieldValues, TContext, TTransformedValues>): UseFormReturn<
  TFieldValues,
  TContext,
  TTransformedValues
> {
  return useRHForm({
    mode: validationMode,
    resolver: yupResolver(schema) as UseFormProps<TFieldValues, TContext, TTransformedValues>['resolver'],
    ...rest,
  });
}

export function useFormContext<
  TFieldValues extends FieldValues = FieldValues,
  TContext = unknown,
  TTransformedValues = TFieldValues,
>() {
  return useRHFormContext<TFieldValues, TContext, TTransformedValues>();
}
